;(function () {
  if (typeof document === 'undefined') return;

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function updateCardHeights() {
    var cards = document.querySelectorAll('.mc-Card_Grid.card-height-container');
    if (!cards.length) return;

    cards.forEach(function (card) {
      // Reset any previous inline height so we can re-measure cleanly
      card.style.height = '';

      if (!isMobile()) {
        // On tablet / desktop let CSS handle sizing
        return;
      }

      var images = card.querySelector('.mc-Card_Images');
      var content = card.querySelector('.mc-Card_Content');
      if (!images || !content) return;

      var imageHeight = images.getBoundingClientRect().height;
      var contentHeight = content.getBoundingClientRect().height;

      // Extra space to account for bottom offset + padding in CSS
      var extraOffset = 455; // 24px bottom + ~35px padding, rounded
      var targetHeight = Math.max(imageHeight, contentHeight + extraOffset);
      if (targetHeight > 0) {
        card.style.height = targetHeight + 'px';
      }
    });
  }

  function onImagesLoaded(callback) {
    var images = Array.prototype.slice.call(
      document.querySelectorAll('.mc-Card_Grid img')
    );
    if (!images.length) {
      callback();
      return;
    }

    var remaining = images.length;
    function done() {
      remaining -= 1;
      if (remaining <= 0) callback();
    }

    images.forEach(function (img) {
      if (img.complete) {
        done();
      } else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
  }

  function init() {
    onImagesLoaded(updateCardHeights);
    window.addEventListener(
      'resize',
      (function () {
        var timeout;
        return function () {
          clearTimeout(timeout);
          timeout = setTimeout(updateCardHeights, 150);
        };
      })()
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

